import apiUrl, { apiConstants } from '../constants';
import { authHeader } from '../helpers';
import { userService } from "./user.service";
import { saveAs } from 'file-saver'

export const baseService = {
    get,
    getBlob,
    post,
    put,
    delete: _delete
};

function get(controller, method, params = null) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    console.log(`${apiConstants.API_URL}/${controller}/${method}${(params!=null? `?`+params:'')}`);

    return fetch(`${apiConstants.API_URL}/${controller}/${method}${(params!=null? `?`+params:'')}`, requestOptions).then(handleResponse);
}

function getBlob(controller, method, params = null) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
        responseType: 'blob'
    };

    console.log(`${apiConstants.API_URL}/${controller}/${method}${(params!=null? `?`+params:'')}`);

    return fetch(`${apiConstants.API_URL}/${controller}/${method}${(params!=null? `?`+params:'')}`, requestOptions).then(handleBlobResponse);
}

function post(obj,controller, method, params = null) {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(),'Content-Type': 'application/json-patch+json','accept':'application/json' },
        body: JSON.stringify(obj)
    };
   
    return fetch(`${apiConstants.API_URL}/${controller}/${method}${(params!=null? `?`+params:'')}`, requestOptions).then(handleResponse);
}

function put(obj,controller, method, params = null) {
    const requestOptions = {
        method: 'PUT',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(obj)
    };

    return fetch(`${apiConstants.API_URL}/${controller}/${method}${(params!=null? `?`+params:'')}`, requestOptions).then(handleResponse);;
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(controller, id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };

    return fetch(`${apiConstants.API_URL}/${controller}/${id}`, requestOptions).then(handleResponse);
}


function handleResponse(response) {

    if (response.status === 401) {
        // auto logout if 401 response returned from api

        console.log("Logged Out")
        userService.logout();
       // location.reload(true);
    }

    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
               // logout();
               console.log("Logged Out")
               userService.logout();
               // location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}


function handleBlobResponse(response) {

    if (response.status === 401) {
        // auto logout if 401 response returned from api

        console.log("Logged Out")
        userService.logout();
       // location.reload(true);
    }

    return response.blob().then(blob =>  saveAs(blob, 'report.xlsx'));
}